<template>
<w-settings-content-template :sideTitle="sideTitle" :default-side="false">
  <div slot="sideContent" class="side-content" style="padding:0px;">
    <el-scrollbar class="bar-visible" style="height:100%;">
      <el-menu v-if="menu !== null" mode="vertical" class="settings-sub-menu" style="width:100%;" :default-active="defaultActiveMenu">
        <el-menu-item v-for="item in menu" :key="item.objCompanyId" :index="item.index" @click="clickMenu(item)">
          <el-tooltip effect="dark" :content="item.objCompanyName" placement="right">
            <span style="max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{item.objCompanyName}}</span>
          </el-tooltip>
        </el-menu-item>
      </el-menu>
    </el-scrollbar>
  </div>
  <div slot="content">
    <w-config-dictionary-view ref="configOidDictionary" :selectVendor="selectVendor" :tmpl-target-type-list="tmplTargetTypeList"></w-config-dictionary-view>
  </div>
</w-settings-content-template>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import isNil from 'lodash/isNil';
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WConfigDictionaryView from './component/ConfigOidDictionaryView';

export default {
  name: 'WConfigOidSettings',
  components: {
    WSettingsContentTemplate,
    WConfigDictionaryView,
  },
  props: {
    activeView: String,
  },
  data() {
    return {
      sideTitle: '네트워크 벤더 목록',
      selectTitle: '',
      menu: [],
      selectVendor: null,
      defaultActiveMenu: null,
      tmplTargetTypeList: [],
    };
  },
  watch: {
    activeView: {
      handler() {
        if (this.activeView === this.$options.name) {
          this.loadData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    loadData() {
      const me = this;
      NetdeviceSettingAPI.getVendorOidList({}).then((result) => {
        if (result.data.success) {
          const menuList = result.data.data;
          if (!isNil(menuList)) {
            menuList.forEach((item, index) => {
              item.index = index.toString();
            });
            me.defaultActiveMenu = menuList[0].index;
            me.selectVendor = cloneDeep(menuList[0]);
          }
          me.menu = menuList;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '벤더', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '벤더', false));
      });
      // 네트워크 설정 > 구성 OID 사전 > 템플릿 타입을 조회한다.
      NetdeviceSettingAPI.getConfigTmplTargetTypelist().then((result) => {
        if (result.data.success) {
          this.tmplTargetTypeList = result.data.data;
        }
      });
    },
    clickMenu(menu) {
      this.selectVendor = cloneDeep(menu);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/OidSettings/ConfigOidSettings/index.vue